export default __webpack_public_path__ + "static/media/vscode.3721028f.png";